import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIModal from 'UIComponents/dialog/UIModal';
import { H2 } from 'UIComponents/elements/headings';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectedForm = crmObject => {
  const name = getPropertyValue(crmObject, PROPERTIES.NAME);
  const formId = getPropertyValue(crmObject, PROPERTIES.FORM_ID);
  return /*#__PURE__*/_jsx("span", {
    children: name
  }, formId);
};
const DeleteDialog = ({
  handleConfirm,
  handleReject,
  selectedObjects,
  disableConfirm
}) => /*#__PURE__*/_jsxs(UIModal, {
  use: "danger",
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: handleReject
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "multiFormDeleteDialog.header",
        options: {
          count: selectedObjects.length
        }
      })
    })]
  }), /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "multiFormDeleteDialog.body"
    }), /*#__PURE__*/_jsx(UIScrollContainer, {
      "data-info": "deleted-forms-listing",
      maxHeight: 300,
      className: "m-top-5",
      children: /*#__PURE__*/_jsx(UIList, {
        styled: true,
        children: selectedObjects.map(SelectedForm)
      })
    })]
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "danger",
      onClick: handleConfirm,
      disabled: disableConfirm,
      "data-action": "delete",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "multiFormDeleteDialog.delete"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "tertiary-light",
      onClick: handleReject,
      disabled: disableConfirm,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancel"
      })
    })]
  })]
});
export default DeleteDialog;